function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 1073;


//////////////////
// WEBPACK FOOTER
// ./~/ethereumjs-vm/dist
// module id = 1073
// module chunks = 0 1 2